exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scrollbar-hide[data-v-5a997897] {\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n  scrollbar-width: none; /* Firefox */\n}\n.scrollbar-hide[data-v-5a997897]::-webkit-scrollbar {\n  display: none; /* Chrome, Safari, and Opera */\n}\nbutton.disabled g path[data-v-5a997897], button.disabled g circle[data-v-5a997897] {\n  filter: grayscale(1);\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/vue-svg-inline-loader/dist/index.min.js!./resources/js/Components/new/VideoSliderView.vue?vue&type=style&index=0&id=5a997897&scoped=true&lang=css
// module id = 423
// module chunks = 5 13